import { __assign, __rest } from "tslib";
import React from 'react';
import cleanLinkSrc from '../../../utils/xss/cleanLinkSrc';
var Entry = function (_a) {
    var mention = _a.mention, theme = _a.theme, searchValue = _a.searchValue, // eslint-disable-line no-unused-vars
    isFocused = _a.isFocused, // eslint-disable-line no-unused-vars
    parentProps = __rest(_a, ["mention", "theme", "searchValue", "isFocused"]);
    return (React.createElement("div", __assign({}, parentProps),
        React.createElement("div", { className: theme.mentionSuggestionsEntryContainer },
            React.createElement("div", { className: theme.mentionSuggestionsEntryContainerLeft },
                React.createElement("img", { alt: "", src: cleanLinkSrc(mention.avatar), className: theme.mentionSuggestionsEntryAvatar, role: "presentation" })),
            React.createElement("div", { className: theme.mentionSuggestionsEntryContainerRight },
                React.createElement("div", { className: theme.mentionSuggestionsEntryText }, mention.name)))));
};
Entry.displayName = 'MentionEntry';
export default Entry;
//# sourceMappingURL=Entry.js.map